module.exports = "<p>\n  We are unable to continue with your online processing for the reason(s) listed below. If you feel you received this message in error, you may click the Help button for contact information to our Help Desk.\nThe credentials you provided do not match what is found in the system.\n</p>\n<button (click)=\"returnToLogin()\"> Return to Login </button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login-error/login-error.component.html
// module id = ./src/app/login/login-error/login-error.component.html
// module chunks = main